"use client";

import { LoadingArea } from "@ui/loading";
import dynamic from "next/dynamic";
import { EnterpriseFAQViewProps } from "./enterprise-faq-view";

const EnterpriseFAQView = dynamic(() => import("./enterprise-faq-view"), {
  ssr: false,
  loading: () => <LoadingArea h="100vh" w="full" />,
});

export const EnterpriseFAQ = (props: EnterpriseFAQViewProps) => {
  return <EnterpriseFAQView {...props} />;
};
